import React, { useEffect, useState } from 'react';
import Grid from '@material-ui/core/Grid';
import Select from 'Components/Forms/Elements/Select';
import TextInput from 'Components/Forms/Elements/TextInput';
import DatePicker from 'Components/Forms/Elements/DatePicker';
import Button from '@material-ui/core/Button';
import Loader from 'Pure/Loader';
import Link from 'Pure/Link';
import bemit from 'Functions/bemit';
import ajaxRequest from 'Functions/ajax/ajaxRequest';
import getFormStatus from 'Components/Forms/Functions/getFormStatus';
import { action, URL } from 'Shared/Routes';
let {
  app,
  moment
} = window;
const DirectBookingForm = ({
  fromModal,
  closeDirectBookingModal,
  ...props
}) => {
  const [loading, setLoading] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const [coworkingSpaces, setCoworkingSpaces] = useState();
  const [booking, setBooking] = useState({});
  const [spaceBooking, setSpaceBooking] = useState([]);
  const [spaceId, setSpaceID] = useState();
  const [exists, setExists] = useState(false);
  const [status_messages, setStatusMessages] = useState({});
  const [status, setStatus] = useState({});
  let openingHour;
  let closingHour;
  const selectStartHours = [];
  const selectEndHours = [];
  const loader = loading === true ? /*#__PURE__*/React.createElement(Loader, {
    className: "c-loader",
    bemit: ['white', 'bg-blue']
  }) : undefined;
  let selectCoworkingSpacesOptions = [];
  coworkingSpaces?.map(coworkingSpace => {
    selectCoworkingSpacesOptions.push({
      value: coworkingSpace.slug,
      label: coworkingSpace.name
    });
  });
  const spaceType = booking?.["booking[coworking_space]"]?.type;
  let selectIsHalftypeOptionOptions = [];
  if (spaceType === "b_seminar" || spaceType === "c_open_coworking_space") {
    selectIsHalftypeOptionOptions = [{
      value: "morning",
      label: "Matin"
    }, {
      value: "afternoon",
      label: "Après-Midi"
    }].filter(object => !spaceBooking.includes(object.value));
  }
  if (spaceType === "b_seminar") {
    selectIsHalftypeOptionOptions = [{
      value: "morning",
      label: "Matin"
    }, {
      value: "afternoon",
      label: "Après-Midi"
    }, {
      value: "day",
      label: "Journée"
    }].filter(object => spaceBooking.length > 0 ? !spaceBooking.includes(object.value) && object.value !== "day" : object);
  }
  if (spaceType === "b_seminar" && spaceBooking.includes("day")) {
    selectIsHalftypeOptionOptions = [{
      value: "indisponible",
      label: "indisponible"
    }];
  }
  const day = moment(booking["booking[date]"]).locale('en').format('dddd').toLocaleLowerCase();
  if (booking?.['booking[coworking_space]']?.type === "a_calm_coworking_space") {
    openingHour = day && booking?.['booking[coworking_space]']?.schedule[day]?.from;
    closingHour = day && booking?.['booking[coworking_space]']?.schedule[day]?.to;
    for (let hour = openingHour; hour <= Number(closingHour - 1); hour++) {
      selectStartHours.push({
        value: hour,
        label: hour + "h00"
      });
      selectEndHours.push({
        value: Number(hour) + Number(1),
        label: Number(hour) + Number(1) + "h00"
      });
    }
  }
  useEffect(() => {
    fetchCoworkingSpaces();
  }, []);
  useEffect(() => {
    fetchSpaceBooking();
  }, [booking['booking[date]'], spaceId]);
  const fetchCoworkingSpaces = async () => {
    try {
      const coworkingSpaces = await ajaxRequest(action('getAllCoworkingSpaces'), {
        etablishment_id: app.state.session.user._etablishment?.id
      });
      setCoworkingSpaces(coworkingSpaces.data);
    } catch (e) {
      console.log(e);
    }
  };
  const fetchSpaceBooking = async id => {
    try {
      const spaceBookings = await ajaxRequest(action('getSpaceBooking'), {
        data: {
          coworking_space_id: spaceId,
          date: booking['booking[date]'] || moment().format('YYYY-MM-DD')
        }
      });
      setSpaceBooking(spaceBookings.booking.map(booking => booking.type));
    } catch (e) {
      console.log(e);
    }
  };
  const handleSubmit = async () => {
    if (loading === true) return;
    setLoading(true);
    try {
      var response = await ajaxRequest(action('CreateDirectBooking'), {
        data: {
          ...booking
        }
      });
    } catch (e) {
      setLoading(false);
      const {
        status_messages,
        E_CODE,
        ...status
      } = e;
      setExists(E_CODE === 'EXISTS');
      setStatusMessages(status_messages);
      return setStatus(status);
    }
    setStatus(response);
    setIsDisabled(true);
    setLoading(false);
    if (typeof props.onValidated === 'function') props.onValidated();
    if (fromModal) {
      setTimeout(() => {
        closeDirectBookingModal();
      }, 1000);
    } else {
      setTimeout(() => {
        app.navigateTo(URL('AdminBookingsDashboard'));
      }, 1000);
    }
  };
  const handleChange = ({
    name,
    value
  }) => {
    if (name === 'booking[coworking_space]') {
      const selectedCoworkingSpace = coworkingSpaces?.filter(coworkingSpace => coworkingSpace.slug === value);
      setBooking({
        ...booking,
        'booking[coworking_space]': selectedCoworkingSpace?.[0],
        'booking[start_hour]': undefined
      });
      const id = selectedCoworkingSpace?.[0].id;
      setSpaceID(id);
    } else setBooking({
      ...booking,
      [name]: value
    });
    setExists(false);
    setStatus({});
    setStatusMessages({
      ...status_messages,
      [name]: undefined
    });
  };
  return /*#__PURE__*/React.createElement("form", {
    className: fromModal ? "" : "c-paper"
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 4,
    className: "u-margin-top-0 u-margin-bottom-0"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "back-title"
  }, "Nouvelle r\xE9servation"), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 6,
    className: "u-flex u-flex-column u-content-end"
  }, /*#__PURE__*/React.createElement(Select, {
    className: "",
    name: "booking[coworking_space]",
    label: "Choisir l'espace",
    onChange: handleChange,
    value: booking['booking[coworking_space]']?.slug,
    options: selectCoworkingSpacesOptions,
    status: status_messages
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 6
  }), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 4,
    className: "u-flex u-flex-column u-content-end"
  }, /*#__PURE__*/React.createElement(DatePicker, {
    onChange: handleChange,
    value: '' || moment().format('YYYY-MM-DD'),
    className: "cutom-date-picker",
    name: "booking[booking_date]",
    label: "Date de la r\xE9servation",
    status: status_messages
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 4,
    className: "u-flex u-flex-column u-content-end"
  }, /*#__PURE__*/React.createElement(DatePicker, {
    onChange: handleChange,
    value: booking['booking[date]'] || '',
    className: "cutom-date-picker",
    name: "booking[date]",
    label: "Date de consommation",
    status: status_messages
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 4,
    className: "u-flex u-flex-column u-content-end"
  }), spaceType === "a_calm_coworking_space" ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 3,
    className: "u-flex u-flex-column u-content-end"
  }, /*#__PURE__*/React.createElement(Select, {
    className: "",
    name: "booking[start_hour]",
    label: "D\xE9but",
    onChange: handleChange,
    value: booking['booking[start_hour]'],
    options: selectStartHours,
    status: status_messages
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 3,
    className: "u-flex u-flex-column u-content-end"
  }, /*#__PURE__*/React.createElement(Select, {
    className: "",
    name: "booking[end_hour]",
    label: "Fin",
    onChange: handleChange,
    value: booking['booking[end_hour]'],
    options: selectEndHours,
    status: status_messages
  }))) : /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 6,
    className: "u-flex u-flex-column u-content-end"
  }, /*#__PURE__*/React.createElement(Select, {
    className: "",
    name: "booking[start_hour]",
    label: "Horaires",
    onChange: handleChange,
    value: booking['booking[start_hour]'],
    options: selectIsHalftypeOptionOptions,
    status: status_messages,
    disabled: spaceBooking.includes("day") ? true : undefined
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 12,
    className: "u-flex u-flex-column u-content-end"
  }, /*#__PURE__*/React.createElement(TextInput, {
    onChange: handleChange,
    value: booking?.['booking[customer][lastname]'],
    name: "booking[customer][lastname]",
    type: "text",
    label: "Nom",
    status: status_messages
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 12,
    className: "u-flex u-flex-column u-content-end"
  }, /*#__PURE__*/React.createElement(TextInput, {
    onChange: handleChange,
    value: booking?.['booking[customer][login]'],
    name: "booking[customer][login]",
    type: "text",
    label: "Email",
    status: status_messages
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 4,
    className: "u-flex u-flex-column u-content-end"
  }, /*#__PURE__*/React.createElement(TextInput, {
    onChange: handleChange,
    value: booking?.['booking[number_of_people]'],
    name: "booking[number_of_people]",
    type: "number",
    label: "Nombre de personne",
    status: status_messages
  })), spaceType !== "c_open_coworking_space" ? /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 4,
    className: "u-flex u-flex-column u-content-end"
  }, /*#__PURE__*/React.createElement(TextInput, {
    onChange: handleChange,
    value: booking?.['booking[amount]'],
    name: "booking[amount]",
    type: "number",
    label: "Montant TTC",
    status: status_messages
  })) : undefined), /*#__PURE__*/React.createElement("div", {
    className: "u-full-width u-flex u-content-end u-padding-top-10 u-padding-bottom-10"
  }, /*#__PURE__*/React.createElement(Button, {
    className: bemit('c-flat-btn', ['primary']),
    component: Link,
    onClick: handleSubmit,
    disabled: isDisabled
  }, "Cr\xE9er la r\xE9servation", loader)), getFormStatus(status));
};
export default DirectBookingForm;
